import IncreamentCard from "../../components/Widgets/DefaultWidgets/IncreamentCard";
import RoadMap from "../../components/Widgets/RoadMapWidget/RoadMap";
import IntlMessages from "../../util/IntlMessages";
import { v4 as uuidv4 } from "uuid";
import { createShortGUID } from "../../util/Scripts";
import { ListScripts } from "../../components/Widgets/ListWidget/Lists/listScripts";
import { widgetsInterfaces } from "./WIdgetInterfaces";
//@ts-ignore
import projectConfig from "@projectConfig";
import { calculateHForWidget } from "../../components/Widgets/WIdgetsScripts/WidgetScripts";
import { getMessagesLayoutHeight } from "../../components/Widgets/ListBuilder/ListBuilderScripts";

export const widgetsSidebarList = [
   {
      showedName: <IntlMessages id="sidebar.right.Active" />,
      name: "Active",
      widgets: [
         {
            name: "questionnaire",
            icon: "card",
            showedName: <IntlMessages id="sidebar.right.Questionnaire" />,
         },
         {
            name: "listSummaries",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.listSummaries" />,
         },
         {
            name: "pieChart",
            icon: "chart-bar",
            showedName: <IntlMessages id="sidebar.right.benefitsChartWidget" />,
         },
         {
            name: "button",
            icon: "button",
            showedName: <IntlMessages id="sidebar.right.Button" />,
         },
         {
            name: "productItem", //productList
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.ProductList" />,
         },
         {
            name: "shoppingBasketCards",
            icon: "shopping-cart",
            showedName: <IntlMessages id="sidebar.right.ShoppingBasketCards" />,
         },
         {
            name: "advertisementList",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.AdvertisementList" />,
         },
         {
            name: "newsletterList",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.NewsletterList" />,
         },
         {
            name: "informationList",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.InformationList" />,
         },
         {
            name: "note",
            icon: "message",
            showedName: <IntlMessages id="sidebar.right.Note" />,
         },
         {
            name: "list",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.List" />,
         },
         {
            name: "table",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.Table" />,
         },
         {
            name: "timeline",
            icon: "timeline",
            showedName: <IntlMessages id="sidebar.right.Timeline" />,
         },
         {
            name: "summary",
            icon: "alert-new",
            showedName: <IntlMessages id="sidebar.right.Summary" />,
         },
         {
            name: "percentageSummary",
            icon: "alert-new",
            showedName: <IntlMessages id="sidebar.right.NewsletterSummary" />,
         },
         {
            name: "newsletterGraph",
            icon: "chart-bar",
            showedName: "Newsletter Graph",
         },
         {
            name: "blogCarousel",
            icon: "carousel",
            showedName: <IntlMessages id="sidebar.right.BlogCarousel" />,
         },
         {
            name: "summaryHopps",
            icon: "alert-new",
            showedName: <IntlMessages id="sidebar.right.SummaryHopps" />,
         },
         {
            name: "levelStatus",
            icon: "alert-new",
            showedName: <IntlMessages id="sidebar.right.LevelStatus" />,
         },
         {
            name: "ranking",
            icon: "diamond",
            showedName: <IntlMessages id="sidebar.right.Ranking" />,
         },
         {
            name: "chartCircle",
            icon: "icon",
            showedName: "Circle Chart",
         },
         {
            name: "kanban",
            icon: "icon",
            showedName: <IntlMessages id="sidebar.kanban" />,
         },
         {
            name: "mobile",
            icon: "phone",
            showedName: <IntlMessages id="sidebar.mobileWidget" />,
         },
         {
            name: "formV3",
            icon: "card",
            showedName: "FormPoc",
         },
         {
            name: "formV2",
            icon: "all-contacts",
            showedName: "Form",
         },
         {
            name: "calendar",
            icon: "calendar",
            showedName: <IntlMessages id="sidebar.right.Calendar" />,
         },
         {
            name: "filter",
            icon: "filter",
            showedName: <IntlMessages id="sidebar.right.Filter" />,
         },
         {
            name: "adSense",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.adSense" />,
         },
         {
            name: "projectSummary",
            icon: "important",
            showedName: <IntlMessages id="sidebar.right.ProjectSummary" />,
         },
         {
            name: "sectionJava",
            icon: "message",
            showedName: <IntlMessages id="sidebar.right.sectionWidget" />,
         },
         {
            name: "customCode",
            icon: "message",
            showedName: <IntlMessages id="sidebar.right.customCode" />,
         },
      ],
   },
   {
      showedName: <IntlMessages id="sidebar.right.Shop" />,
      name: "Shop",
      widgets: [
         {
            name: "IncreamentCard",
            //@ts-ignore
            widget: <IncreamentCard />,
            showedName: <IntlMessages id="sidebar.right.IncreamentCard" />,
         },
         {
            name: "RoadMap",
            //@ts-ignore
            widget: <RoadMap />,
            showedName: <IntlMessages id="sidebar.right.RoadMap" />,
         },
      ],
   },
   {
      showedName: <IntlMessages id="sidebar.right.Future" />,
      name: "Future",
      widgets: [
         {
            name: "myBoards",
            icon: "scroll",
            showedName: <IntlMessages id="sidebar.right.myBoards" />,
         },
         {
            name: "lineGraph",
            icon: "scroll",
            showedName: <IntlMessages id="sidebar.right.lineGraph" />,
         },
         {
            name: "infiniteList",
            icon: "scroll",
            showedName: <IntlMessages id="sidebar.right.infiniteList" />,
         },
         {
            name: "photoWidget",
            icon: "image",
            showedName: <IntlMessages id="sidebar.right.photoWidget" />,
         },
         {
            name: "advancedSearch",
            icon: "search",
            showedName: <IntlMessages id="sidebar.right.AdvancedSearch" />,
         },
         {
            name: "cardReport",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.sumReport" />,
         },
         {
            name: "photoGallery",
            icon: "image",
            showedName: <IntlMessages id="sidebar.right.PhotoGallery" />,
         },

         {
            name: "chart",
            icon: "chart",
            showedName: <IntlMessages id="sidebar.right.Chart" />,
         },

         {
            name: "formBuilder",
            icon: "plain-list-divider",
            showedName: <IntlMessages id="sidebar.right.FormBuilder" />,
         },
         {
            name: "formV3",
            icon: "card",
            showedName: "FormPoc",
         },
      ],
   },
   {
      showedName: <IntlMessages id="sidebar.right.System" />,
      name: "System",
      widgets: [
         {
            name: "translation",
            icon: "translation",
            showedName: <IntlMessages id="sidebar.right.Translations" />,
         },
         {
            name: "boardsManager",
            icon: "table",
            showedName: <IntlMessages id="sidebar.right.BoardsManager" />,
         },
         {
            name: "formBuilder",
            icon: "plain-list-divider",
            showedName: <IntlMessages id="sidebar.right.FormBuilder" />,
         },
         {
            name: "listsBuilder",
            icon: "plain-list-divider",
            showedName: <IntlMessages id="sidebar.right.ListBuilder" />,
         },
      ],
   },
];

export const initialWidgetsData = (
   widgetKey,
   currentBoard,
   addWidgetInSheet?,
   setWidgetSettings?,
   dispatch?,
   isSidebarOpen?,
   initialData?,
) => {
   if (isSidebarOpen) {
      isSidebarOpen(false);
   }

   if (widgetKey === "button") {
      const button: widgetsInterfaces = {
         id: uuidv4(),
         name: "button",
         btnTitle: createShortGUID(widgetKey, currentBoard.id),
         contentKey: createShortGUID(`${widgetKey}.content`, currentBoard.id),
         btnUrl: "",
         configId: "",
         chosenOperation: "",

         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 6,
         imageFileId: null,
         xlWidth: 6,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(button));
      }
      return button;
   } else if (widgetKey === "list") {
      const list: widgetsInterfaces | any = {
         id: uuidv4(),
         name: "list",
         chatButtonTitle: createShortGUID("list", currentBoard.id),
         backgroundColourHex: "#fff",
         listWidgetSeries: [
            {
               listWidgetSerieKey: 0,
               name: "list",
               query: "Click to add query",
               listId: "-",
               itemsPerPage: "10",
               listWidgetSerieSettings: ListScripts.getBasicSerieSettings(),
               columnProperties: [],
            },
         ],
         maxHeight: 30,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         mapLocalizationFieldName: "",
         mapClickFilterColName: "",
         mapDefaultZoomLevel: 14,
         mapViewListSerie: null,
         mapListSerie: null,
         mapIndependentSerie: null,
         mapPointColName: null,
         mapDistanceColName: null,
         mapAddressColName: null,
         showMap: false,
         filterByLocation: false,
         setDistanceColumnHidden: true,
         distanceToFilter: 30,
         maxDistanceToFilter: 100,
         showUrlButton: false,
         ulrButtonTitle: createShortGUID(widgetKey, currentBoard.id),
      };

      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(list));
         dispatch(setWidgetSettings(list));
      }
      return list;
   } else if (widgetKey === "table") {
      const table: widgetsInterfaces | any = {
         id: uuidv4(),
         name: "table",
         backgroundColourHex: "#fff",
         tableSeries: [
            {
               seriesKey: `series-${uuidv4()}`,
               name: "-",
               //query: "Click to add query",
               dataId: initialData ? initialData : "-",
               itemsPerPage: 10,
               defaultFilterId: "",
               //listWidgetSerieSettings: ListScripts.getBasicSerieSettings(),
               //columnProperties: []
            },
         ],
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
      };

      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(table));
         dispatch(setWidgetSettings(table));
      }
      return table;
   } else if (widgetKey === "lineGraph") {
      const lineGraph: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         listId: 508,

         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#e2e8f0",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(lineGraph));
      }
      return lineGraph;
   } else if (widgetKey === "map") {
      const map: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         localizationFieldName: "Współrzędne Klienta",
         defaultZoomLevel: 14,
         listId: 182,
         viewListId: 183,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         maxHeight: 12,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(map));
      }
      return map;
   } else if (widgetKey === "summary") {
      const summary: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         listId: null,
         itemsPerPage: 10,
         maxHeight: 6,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 8,
         xlWidth: 8,
         icon: null,
         imageFileId: null,
         columnToSummarize: null,
         description: null,
         textColor: "#000",
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(summary));
      }
      return summary;
   } else if (widgetKey === "percentageSummary") {
      const percentageSummary: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 6,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 8,
         xlWidth: 8,
         icon: null,
         imageFileId: null,
         titleKey: null,
         imageUrl: null,
         formId: null,
         dataId: null,
         humanFieldName: null,
         tooltipText: null,
         textColor: "#000",
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(percentageSummary));
      }
      return percentageSummary;
   } else if (widgetKey === "newsletterGraph") {
      const newsletterGraph: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
         titleKey: "Newsletter Graph",
         imageUrl: null,
         xHid: null,
         listId: null,
         series: [],
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(newsletterGraph));
      }
      return newsletterGraph;
   } else if (widgetKey === "summaryHopps") {
      const summaryHopps: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,

         listId: null,
         timelineListId: null,
         redirectUrl: "",
         itemsPerPage: 10,
         maxHeight: 6,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 6,
         xlWidth: 6,
         columnToDisplayHopps: null,
         columnToDisplayPosition: null,
         columnToDisplayRanking: null,
         columnToDisplayPoints: null,
         columnToDisplayLeftPoints: null,
         columnToCalculateTimeline: null,
         textColor: "#000",
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(summaryHopps));
      }
      return summaryHopps;
   } else if (widgetKey === "shoppingBasketCards") {
      const ShoppingBasket: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 45,
         lgWidth: 45,
         xlWidth: 45,
         backgroundColourHex: "#fff",
         allowExceedStoreLimit: true,
         userBudgetIdColTechname: "",
         currency: "",
         allowExceedUserBudget: true,
         orderWorkflowConfigId: 0,
         showPrice: true,
         shopName: "",
         changeQuantity: true,
         showAdditionalInfo: true,
         listId: 0,
         maxHeight: 25,
         showImage: true,
         imageWidth: 150,
         imageHeight: 150,
         titleColumn: "",
         unit_priceColumn: "",
         currencyColumn: "",
         quantityColumn: "",
         amountColumn: "",
         photoColumnColumn: "",
         category_1Column: "",
         category_2Column: "",
         category_3Column: "",
         orderTypeColumn: "",
         item_idColumn: "",
         showActions: false,
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(ShoppingBasket));
      }
      return ShoppingBasket;
   } else if (widgetKey === "levelStatus") {
      const levelStatus: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         listId: null,
         maxHeight: 5,
         xsWidth: 18,
         smWidth: 18,
         mdWidth: 18,
         lgWidth: 5,
         xlWidth: 5,
         columnToDisplayLevel: null,
         columnToDisplayPhoto: null,
         columnToDisplayPoints: null,
         listIdForPoints: null,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(levelStatus));
      }
      return levelStatus;
   } else if (widgetKey === "ranking") {
      const levelStatus: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         listId: null,
         rankingHeaderTranslationKey: createShortGUID(widgetKey, currentBoard.id),
         maxHeight: 8,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 13,
         xlWidth: 13,
         columnToDisplayUser: null,
         columnToDisplayPosition: null,
         columnToDisplayPoints: null,
         itemsPerPage: 10,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(levelStatus));
      }
      return levelStatus;
   } else if (widgetKey === "newsletter") {
      const newsletter: widgetsInterfaces = {
         id: uuidv4(),
         newsletterId: 1,
         name: widgetKey,
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(newsletter));
      }
      return newsletter;
   } else if (widgetKey === "cardReport") {
      const cardReport: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 5,
         xsWidth: 4,
         smWidth: 4,
         mdWidth: 4,
         lgWidth: 4,
         xlWidth: 4,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(cardReport));
      }
      return cardReport;
   } else if (widgetKey === "photoGallery") {
      const photoGallery: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         backgroundColourHex: "#fff",
         title: "tytuł galerii",
         photos: [
            {
               src: "https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_b.jpg",
               thumbnail: "https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_n.jpg",
               thumbnailWidth: 320,
               thumbnailHeight: 212,
            },
            {
               src: "https://c2.staticflickr.com/9/8356/28897120681_3b2c0f43e0_b.jpg",
               thumbnail: "https://c2.staticflickr.com/9/8356/28897120681_3b2c0f43e0_n.jpg",
               thumbnailWidth: 320,
               thumbnailHeight: 212,
            },
            {
               src: "https://c4.staticflickr.com/9/8887/28897124891_98c4fdd82b_b.jpg",
               thumbnail: "https://c4.staticflickr.com/9/8887/28897124891_98c4fdd82b_n.jpg",
               thumbnailWidth: 320,
               thumbnailHeight: 212,
            },
         ],
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         columns: 2,
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(photoGallery));
      }
      return photoGallery;
   } else if (widgetKey === "photoWidget") {
      const photoWidget: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         listId: null,
         dataId: null,
         backgroundColourHex: "#fff",
         title: "photo",
         maxHeight: 5,
         xsWidth: 8,
         smWidth: 8,
         mdWidth: 8,
         lgWidth: 8,
         xlWidth: 8,
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(photoWidget));
      }
      return photoWidget;
   } else if (widgetKey === "advertisementList") {
      const advertisementList: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         chatPrivateButtonTitle: createShortGUID(widgetKey, currentBoard.id),
         chatPublicButtonTitle: createShortGUID(widgetKey, currentBoard.id),
         title: createShortGUID(widgetKey, currentBoard.id),
         isPhotoVisible: true,
         isColumnTitleVisible: true,
         showDisplayOptions: false,
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         itemsPerPage: 10,
         backgroundColourHex: "#fff",
         showPrivateChatButton: false,
         showPublicChatButton: false,
         privateChatTitle: "",
         publicChatTitle: "",
         privateChatSubtitle: "",
         publicChatSubtitle: "",

         usersTechName: "",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(advertisementList));
         dispatch(setWidgetSettings(advertisementList));
      }
      return advertisementList;
   } else if (widgetKey === "newsletterList") {
      const newsletterList: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: createShortGUID(widgetKey, currentBoard.id),
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         itemsPerPage: 20,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(newsletterList));
         dispatch(setWidgetSettings(newsletterList));
      }
      return newsletterList;
   } else if (widgetKey === "informationList") {
      const InformationList: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: createShortGUID(widgetKey, currentBoard.id),
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         itemsPerPage: 20,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(InformationList));
         dispatch(setWidgetSettings(InformationList));
      }
      return InformationList;
   } else if (widgetKey === "note") {
      const note: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: createShortGUID(widgetKey, currentBoard.id),
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(note));
      }
      return note;
   } else if (widgetKey === "productItem") {
      //productList
      const productList: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: "Lista ogłoszeń",
         maxHeight: 9,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         listTitle: createShortGUID(widgetKey, currentBoard.id),
         backgroundColourHex: "#fff",
         itemIdColumn: "",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(productList));
      }
      return productList;
   } else if (widgetKey === "chartCircle") {
      const chartCircle: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: "Chart",
         maxHeight: 4,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         links: [],
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(chartCircle));
      }
      return chartCircle;
   } else if (widgetKey === "chart") {
      const chart: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: "Chart",
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         links: [],
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(chart));
      }
      return chart;
   } else if (widgetKey === "kanban") {
      const kanban: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: "Chart",
         maxHeight: 29,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         links: [],
         backgroundColourHex: "#fff",
         blockHorizontalMovement: false,
         blockVerticalMovement: false,
         sortColumns: true,
         sortRows: true,
         showSortColumns: true,
         showSortRows: true,
         sortColumnsByName: true,
         sumNumberOfRowsInColumn: false,
         horizontalPlacementSettings: [],
         verticalPlacementSettings: [],
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(kanban));
      }
      return kanban;
   } else if (widgetKey === "linkWeb") {
      const links: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         webKey: "",
         widgetKeyKey: "",
         linkwidgetKeyTitleTranslationKey: "Links",
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 6,
         xlWidth: 6,
         links: [],
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(links));
      }
      return links;
   } else if (widgetKey === "projectSummary") {
      const projectSummary: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: "Chart",
         maxHeight: 8,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         links: [],
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(projectSummary));
      }
      return projectSummary;
   } else if (widgetKey === "iconWeb") {
      const icons: widgetsInterfaces = {
         id: uuidv4(),
         webKey: "",
         widgetKeyKey: "",
         name: widgetKey,
         tooltipTranslationKey: "Icons",
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 6,
         xlWidth: 6,
         icons: [],
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(icons));
      }
      return icons;
   } else if (widgetKey === "bannerWeb") {
      const bannerWeb: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         buttonTitleTranslationKey: "button translation",
         url: "change banner url",
         bannerwidgetKeyTitleTranslationKey: "",
         webKey: "",
         widgetKeyKey: "",
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 12,
         xlWidth: 12,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(bannerWeb));
      }
      return bannerWeb;
   } else if (widgetKey === "infoLineImageWeb") {
      const infoLineImageWeb: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         imagewidgetKeyTitleTranslationKey: "",
         images: [],
         webKey: "",
         widgetKeyKey: "",
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 12,
         xlWidth: 12,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(infoLineImageWeb));
      }
      return infoLineImageWeb;
   } else if (widgetKey === "pictureWeb") {
      const pictureWeb: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         webKey: "",
         widgetKeyKey: "",
         hrefString: "",
         textString: "",
         fileName: "",
         fileId: "",
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 12,
         xlWidth: 12,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(pictureWeb));
      }
      return pictureWeb;
   } else if (widgetKey === "advancedSearch") {
      const advancedSearch: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: "Wyszukiwarka",
         searchInput: [],
         //@ts-ignore
         selectedwidgetKeyId: 0,
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(advancedSearch));
      }
      return advancedSearch;
   } else if (widgetKey === "translation") {
      const translation: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         visibleAddTranslation: true,
         visibleDeleteTranslation: true,
         columns: null,
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(translation));
      }
      return translation;
   } else if (widgetKey === "form") {
      const form: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         formId: "",
         maxHeight: 6,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(form));
      }
      return form;
   } else if (widgetKey === "formV2") {
      const form: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         formId: "",
         maxHeight: 6,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(form));
      }
      return form;
   } else if (widgetKey === "formV3") {
      const form: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         formId: "",
         maxHeight: 45,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(form));
      }
      return form;
   } else if (widgetKey === "questionnaire") {
      const form: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         formId: "",
         maxHeight: 45,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(form));
      }
      return form;
   } else if (widgetKey === "formBuilder") {
      const formBuilder: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         formId: null,
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(formBuilder));
      }
      return formBuilder;
   } else if (widgetKey === "timeline") {
      const timeline: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         listId: null,
         graphQlQuery: "",
         dateAttribute: "Data utworzenia zadania",
         titleAttribute: "Projekt",
         descriptionAttribute: "Nazwa zadania",
         iconAttribute: "data-display",
         noDataInfoTranslationKey: "timeline.noDataInfoTranslationKey",
         itemsPerwidgetKey: 10,
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(timeline));
      }
      return timeline;
   } else if (widgetKey === "blogCarousel") {
      const blogCarousel: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         listId: null,
         itemsPerwidgetKey: 10,
         widgetKeyTitle: "Blog",
         titleTranslationKey: createShortGUID(widgetKey, currentBoard.id),
         slidesToShow: 4,
         bannerTitle: "Miniatura",
         singleItemTitleColumn: "Tytuł",
         singleItemDescriptionColumn: "Treść",
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(blogCarousel));
      }
      return blogCarousel;
   } else if (widgetKey === "IncreamentCard") {
      const IncreamentCard: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 6,
         xlWidth: 6,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(IncreamentCard));
      }
      return IncreamentCard;
   } else if (widgetKey === "RoadMap") {
      const RoadMap: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 6,
         xlWidth: 6,
         xsHeight: 6,
         smHeight: 6,
         mdHeight: 6,
         lgHeight: 6,
         backgroundColourHex: "#fff",
         xlHeight: 6,
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(RoadMap));
      }
      return RoadMap;
   } else if (widgetKey === "calendar") {
      const Calendar: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         calendarId: 981,
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
         calendarColumns: {
            eventId: null,
            title: null,
            allDay: null,
            startDate: null,
            endDate: null,
            startHour: null,
            endHour: null,
         },
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(Calendar));
      }
      return Calendar;
   } else if (widgetKey === "filter") {
      const filter: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 10,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 6,
         xlWidth: 6,
         isSaveAsVisible: true,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(filter));
      }
      return filter;
   } else if (widgetKey === "mobile") {
      const mobile: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 5,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 12,
         lgWidth: 6,
         xlWidth: 6,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(mobile));
      }
      return mobile;
   } else if (widgetKey === "boardsManager") {
      const boardsManager: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 20,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(boardsManager));
      }
      return boardsManager;
   } else if (widgetKey === "adSense") {
      const adSense: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         dataAdSlot: "",
         dataAdClient: "",
         maxHeight: 16,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(adSense));
      }
      return adSense;
   } else if (widgetKey === "infiniteList") {
      const listId = projectConfig.infiniteListId;

      const infiniteList: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         maxHeight: 90,
         listId: listId,
         xsWidth: 13,
         smWidth: 13,
         mdWidth: 13,
         lgWidth: 13,
         xlWidth: 13,
         backgroundColourHex: "#e2e8f0",
         sysActionsVisibility: { showMoveForward: true, showAskQuestion: true },
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(infiniteList));
      }
   } else if (widgetKey === "sectionJava") {
      const sectionWidget: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         title: "section",
         titleKey: createShortGUID(widgetKey, currentBoard.id),
         linePosition: "under",
         maxHeight: 10,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(sectionWidget));
      }
   } else if (widgetKey === "myBoards") {
      const myBoardsWidget: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         titleKey: createShortGUID(widgetKey, currentBoard.id),
         maxHeight: 10,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(myBoardsWidget));
      }
   } else if (widgetKey === "customCode") {
      const customCode: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         titleKey: createShortGUID(widgetKey, currentBoard.id),
         maxHeight: 10,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(customCode));
      }
   } else if (widgetKey === "listSummaries") {
      const benefits: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         titleKey: createShortGUID(widgetKey, currentBoard.id),
         maxHeight: 10,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(benefits));
      }
   } else if (widgetKey === "pieChart") {
      const benefitsChart: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         titleKey: createShortGUID(widgetKey, currentBoard.id),
         listId: "",
         maxHeight: 10,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(benefitsChart));
      }
   } else if (widgetKey === "listsBuilder") {
      const listsBuilder: widgetsInterfaces = {
         id: uuidv4(),
         name: widgetKey,
         titleKey: createShortGUID(widgetKey, currentBoard.id),
         maxHeight: calculateHForWidget(getMessagesLayoutHeight() || 10) - 1,
         xsWidth: 24,
         smWidth: 24,
         mdWidth: 24,
         lgWidth: 24,
         xlWidth: 24,
         backgroundColourHex: "#fff",
      };
      if (addWidgetInSheet && setWidgetSettings && dispatch) {
         dispatch(addWidgetInSheet(listsBuilder));
      }
   }
};
